var title = $('.custom_tab > .tab_tit li');
title.click(function(){
  var index = $(this).index();
  var content = $('.custom_tab > .tab_con > div');
  $(this).addClass('active');
  $(this).siblings().removeClass('active');
  content.eq(index).addClass('active');
  content.eq(index).siblings().removeClass('active');
})

$('div[id*="rich-text"] .collage.with-richtext .rich-text .button').click(
  function () {
    $('div[id*="rich-text"] .collage.with-richtext .rich-text > div:nth-of-type(2)').toggle();
    $(this).toggleClass("on");
  }
);


// $(window).resize(function () {
//   if ($(window).width() < 600) {
//     $('div[id*="rich-text"] .collage.with-richtext .rich-text .button').click(
//       function () {
//         $('div[id*="rich-text"] .collage.with-richtext .rich-text > div:nth-of-type(2)').toggle();
//         $(this).toggleClass("on");
//       }
//     );
//   } else {
//     $('div[id*="rich-text"] .collage.with-richtext .rich-text > div:nth-of-type(2)').removeAttr("style");
//   }
// });



var host = window.location.href;
var InBodyDial = '.faqwrap .faqmenu li:nth-of-type(1) a';
var InBodyBAND = '.faqwrap .faqmenu li:nth-of-type(2) a';
var InbodyApp = '.faqwrap .faqmenu li:nth-of-type(3) a';
var PUSH = '.faqwrap .faqmenu li:nth-of-type(4) a';
var Others = '.faqwrap .faqmenu li:nth-of-type(5) a';


if (host == 'https://inbodyshop.com/pages/inbodydial') {
   $(InBodyDial).css('color','#000');
} else if (host == 'https://inbodyshop.com/pages/inbodyband') {
   $(InBodyBAND).css('color','#000');
} else if(host == 'https://inbodyshop.com/pages/inbody-app-2') {
  $(InbodyApp).css('color','#000');
} else if(host == 'https://inbodyshop.com/pages/push') {
  $(PUSH).css('color','#000');
} else if(host == 'https://inbodyshop.com/pages/others') {
  $(Others).css('color','#000');
}

// // header
// window.addEventListener('scroll', function(){
//     var wp = window.pageYOffset;

//     if(wp > 0){
//         $('header').css({'background-color':'#fff'});
        
//     }else{
//         $('header').css({'background-color':'transparent'});
//     }

// })
